import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Dialog } from '@factorialco/f0-react'
import { LOCAL_STORAGE_KEYS } from 'config/Vars'
import { useLocalStorage } from 'usehooks-ts'

import i18n from 'modules/core/lib/i18n'

import useChangeView from 'modules/shift_management/hooks/useChangeView'
import { COVERAGE_SECTION_HEIGHT } from 'modules/shift_management/lib/consts/ShiftManagementCoverage'

interface Props {
  onClose: () => void
  handleGenerateCoverage: () => void
}

const NoCoverageModal = ({ onClose, handleGenerateCoverage }: Props) => {
  const [, setLocalStorageResizeHeight] = useLocalStorage<number>(
    LOCAL_STORAGE_KEYS.shiftManagementCoverageResizeHeight,
    0
  )
  const { view, onChangeRoute } = useChangeView()

  const handleManually = () => {
    view.isByAreas && onChangeRoute(`${view.viewType}/employees`)
    setLocalStorageResizeHeight(COVERAGE_SECTION_HEIGHT)
    onClose()
  }
  return (
    <>
      <F0Dialog
        isOpen
        onClose={onClose}
        position="center"
        title={i18n.t('shift_management.coverage_section.automation.no_coverage_modal.title')}
        primaryAction={{
          label: i18n.t(
            'shift_management.coverage_section.automation.no_coverage_modal.generate_button'
          ),
          onClick: () => {
            handleGenerateCoverage()
          },
        }}
        secondaryAction={{
          label: i18n.t(
            'shift_management.coverage_section.automation.no_coverage_modal.add_button'
          ),
          onClick: handleManually,
        }}
      >
        <Box padding="s20">
          <Text.Normal className="text-f1-foreground-secondary" whiteSpace="breakSpaces">
            {i18n.t('shift_management.coverage_section.automation.no_coverage_modal.description')}
          </Text.Normal>
        </Box>
      </F0Dialog>
    </>
  )
}

export { NoCoverageModal }
